import React from "react";
import { connect } from "react-redux";
import _ from "lodash";
import Loader from "@/components/loader/Loader";
import PropTypes from "prop-types";
import * as resActions from "@/modules/resources";
import * as tokenActions from "@/modules/apitoken";
import * as formActions from "@/modules/forms3";
import Tabs from "Components/tabs/Tabs";
import Limits from "./tabs/Limits";
import PanelSettings from "./tabs/PanelSettings";
import Notifications from "./tabs/Notifications";
import { alertSuccess } from "@/utils/alerts";
import withFormState from "Components/withFormState";
import QboxmailApi from "@/qboxmailApi";
import { formatServerErrors } from "Utils/serverFormats";
import t from "Utils/translation";
import { displayFormattedDate } from "Utils/dateFormats";
import sessionStore from "@/stores/session";
import DetailStatus from "Components/detailStatus/DetailStatus";
import DetailInfo from "Components/detailInfo/DetailInfo";
import cx from "classnames";
import s from "./Show.scss";

const formInitialState = {};

const ContextTypes = {
  router: PropTypes.object,
  isLoggedUserTrial: PropTypes.func,
  getLoggedUser: PropTypes.func,
  getLoggedUserType: PropTypes.func,
  isMobileDevice: PropTypes.func,
  isMediaMobile: PropTypes.func,
  isMediaSM: PropTypes.func,
  isMediaMD: PropTypes.func,
  isMediaLG: PropTypes.func,
};

class SettingsScreen extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      loggedUserType: context.getLoggedUserType(),
      showInfo: this.props.isMediaMobile ? false : true,
    };
  }

  UNSAFE_componentWillMount() {
    this.props.refreshAccount();
    const type = this.state.loggedUserType;

    if (type === "EmailAccount" || type === "Postmaster") {
      this.props.getDomain(this.context.getLoggedUser().domain_code);
    }
  }

  UNSAFE_componentWillReceiveProps({ isAccountRefreshing, account }) {
    if (!isAccountRefreshing && this.props.isAccountRefreshing) {
      this.props.setInitialValues({
        language: account.language,
        timezone: account.timezone,
        allow_nets: account.allow_nets && account.allow_nets[0] === "0.0.0.0/0" ? [] : account.allow_nets,
        email_overquota_email: account.email_overquota_email,
        notification_email: account.notification_email,
        domain_create_callback: account.domain_create_callback,
        email_overquota_callback: account.email_overquota_callback,
        notification_url: account.notification_url,
        domain_limit_tracemail_21_days_default: account.domain_limit_tracemail_21_days_default,
      });
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.isMediaMobile !== this.props.isMediaMobile) {
      this.setState({
        showInfo: this.props.isMediaMobile ? false : true,
      });
    }
  }

  submitForm = async (e) => {
    const { refreshAccount, setFormLoading, unsetFormLoading, setFormErrors, formData } = this.props;
    const account = this.context.getLoggedUser();

    e.preventDefault();

    setFormLoading();
    const values = _.clone(formData);

    if (values.password === "") delete values.password;
    if (values.password_confirmation === "") {
      delete values.password_confirmation;
    }

    if (values.language) {
      sessionStore.setSettings({ language: values.language });
    }

    const api = new QboxmailApi({ useCookie: true });

    try {
      const resp = await api.editAccount(account.code, values);
      unsetFormLoading();
      alertSuccess(t("alert.accountUpdatedSuccess"));
    } catch (response) {
      formatServerErrors(response).then((errors) => {
        setFormErrors(errors);
        unsetFormLoading();
      });
      return Promise.reject(response);
    }
  };

  toggleInfo = () => {
    this.setState({ showInfo: !this.state.showInfo });
  };

  render() {
    const { domain, isDomainLoading, isAccountRefreshing } = this.props;

    const { showInfo } = this.state;

    const { isMobileDevice, isMediaMobile, isMediaSM, isMediaMD, isMediaLG } = this.context;

    const user = this.context.getLoggedUser();
    const loggedUserType = this.context.getLoggedUserType();

    if (
      !user ||
      ((loggedUserType === "EmailAccount" || loggedUserType === "Postmaster") && isDomainLoading) ||
      isAccountRefreshing
    ) {
      return <Loader {...this.props} />;
    }

    let customersManagersExtraTabs = {};

    if (loggedUserType === "Customer" || loggedUserType === "Manager") {
      customersManagersExtraTabs[t("tab.limits")] = <Limits user={user} />;
      customersManagersExtraTabs[t("tab.notification")] = (
        <Notifications {...this.props} submitForm={this.submitForm} user={user} userCode={user.code} />
      );
    }

    return (
      <div className={cx(s.userSettings, { [s.isAdmin]: loggedUserType === "Admin" })}>
        <div className={s.navigation}>
          <div />
          <div className={s.viewSectionLabel}>{t("section.view.user.settings")}</div>
        </div>

        <div className={s.header}>
          <div className={s.wrapTitle}>
            <div className="sectionTitle">
              {loggedUserType === "EmailAccount" || loggedUserType === "Postmaster"
                ? user.email_address
                : `${user.firstname} ${user.lastname}`}
            </div>

            {isMediaMobile() && (
              <div className={cx(s.showInfo, "internalLink")} onClick={this.toggleInfo}>
                {showInfo ? t("button.details.hide") : t("button.details.show")}
              </div>
            )}
          </div>
          {showInfo && (
            <div className={s.subtitle}>
              {loggedUserType !== "Admin" && <DetailStatus status={user.status} />}

              <div className="sectionDesc">{user.email_address}</div>
            </div>
          )}

          {showInfo && (
            <div className={s.info}>
              <DetailInfo label={t("detailInfo.label.code")} info={user.code} inLine />
              <DetailInfo label={t("detailInfo.label.created")} info={displayFormattedDate(user.created_at)} inLine />
            </div>
          )}
        </div>

        {loggedUserType === "Admin" ? (
          <PanelSettings
            className={s.settings}
            submitForm={this.submitForm}
            {...this.props}
            user={user}
            userCode={user.code}
          />
        ) : (
          <Tabs
            {...this.props}
            className={s.settings}
            tabs={{
              [t("tab.general")]: (
                <PanelSettings submitForm={this.submitForm} {...this.props} user={user} userCode={user.code} />
              ),
              ...customersManagersExtraTabs,
            }}
          />
        )}
      </div>
    );
  }
}

SettingsScreen.contextTypes = ContextTypes;

const mapStateToProps = (state) => ({
  account: resActions.getData("account.data.0", state),
  isAccountRefreshing: state.resources.account && state.resources.account.refreshResource,
  updateAccountPanelSettingsForm: state.forms3.updateAccountPanelSettings,
  updateNotificationsSettingsForm: state.forms3.updateNotificationsSettings,
  isGeneratingToken: state.apitoken.isGenerating,
  isResettingToken: state.apitoken.isResetting,
  apiToken: state.apitoken.token,
  apiTokenResetted: state.apitoken.resetted,
  domain: resActions.getData("domain.data", state)[0],
  isDomainLoading: resActions.isResourceLoading("domain", state),
});

const mapDispatchToProps = (dispatch) => ({
  updateAccount: (code, formValues, formName) =>
    dispatch(formActions.submitForm(formValues, `/users/${code}`, "PUT", formName)),
  refreshAccount: () => dispatch(resActions.callApi("refreshAccount", "account")),
  generateApiToken: (userCode) => dispatch(tokenActions.generateApiToken(userCode)),
  destroyApiToken: (userCode) => dispatch(tokenActions.destroyApiToken(userCode)),
  getDomain: (code) => dispatch(resActions.callApi("getDomain", "domain", code)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withFormState(SettingsScreen, formInitialState));
